import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { nanoid } from 'nanoid'
import { Box, Image } from 'theme-ui'
import { useMediaServerURL } from '../../../Context/MediaServerContext'
import transformCloudinaryToMediaServer from '../../../helpers/transformCloudinaryToMediaServer'
import HeroContent from '../heroComponents/HeroContentNoIndex'
import Shout from '../../Shout/v1/Index'
import fetchGallery from '../../../helpers/fetchGallery'
import ImageSelector from '../../Images/ImageSelector'
import componentOptionsSelector from '../../../helpers/componentOptionsSelector'

export default function Hero(props) {
  const mediaServerURL = useMediaServerURL()
  // ====================================
  // =========== Destructing ============
  // ====================================
  const {
    options,
    locationIndex,
    // locations,
    businessData,
    // configData,
    allGeneral,
    poweredImages,
    variantName,
    isMultiLocationSite,
    shoutData,
    gonationID
  } = props

  const storyId = options.storyId?.[locationIndex]
  const storyTag = options.storyTag?.[locationIndex]

  const {
    logoHero,
    titles,
    subtitles,
    texts,
    textType,
    ctaLinks,
    ctaNames,
    links,
    images,
    displayAlbums,
    interval,
    speed,
    slidesToShow,
    autoplay,
    slidedots,
    sliderSettings,
    containerStyles,
    shoutContainerStyles
  } = componentOptionsSelector(options, locationIndex, storyId, allGeneral, storyTag)

  const {
    // cover: { imageBaseUrl, imagePrefix },
    avatar: { imageBaseUrl: logoBaseUrl, imagePrefix: logoPrefix },
    // name,
    // street,
    desc,
    city
    // state,
    // zip,
    // phone,
  } = businessData

  // ====================================
  // ========== Component State =========
  // ====================================

  const [gallery, setGallery] = useState(null)

  // ====================================
  // ===== Variable Transformations =====
  // ====================================

  const NextArrow = ({ currentSlide, slideCount, ...props }) => <FontAwesomeIcon {...props} icon={faChevronRight} />

  const PrevArrow = ({ currentSlide, slideCount, ...props }) => <FontAwesomeIcon {...props} icon={faChevronLeft} />

  const settings = {
    dots: slidedots ? slidedots : true,
    infinite: true,
    arrows: true,
    autoplay: autoplay ? autoplay : true,
    speed: speed ? speed : 1500,
    autoplaySpeed: interval ? interval : 5000,
    slidesToShow: slidesToShow?.[locationIndex] ?? 1,
    slidesToScroll: 1,
    repeat: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    pauseOnHover: false,
    ...sliderSettings
  }

  const styles = containerStyles ? JSON.parse(containerStyles) : {}
  const shoutStyles = shoutContainerStyles ? JSON.parse(shoutContainerStyles) : {}

  // Helper function to transform image URLs if using new media server
  const transformImageURL = imageUrl => {
    if (!imageUrl) return imageUrl

    // If we're using the new media server and the URL contains the old cloudinary URL
    if (mediaServerURL !== 'https://res.cloudinary.com/gonation' && imageUrl.includes('res.cloudinary.com/gonation')) {
      return transformCloudinaryToMediaServer(imageUrl, undefined, mediaServerURL)
    }

    return imageUrl
  }

  // Transform images array if it exists
  const transformedImages = images ? images.map(transformImageURL) : images

  // ====================================
  // ========= async requests ===========
  // ====================================

  const fetchData = async (gonationID, displayAlbums) => {
    const data = await fetchGallery(gonationID, displayAlbums, mediaServerURL)
    setGallery(data[0])
  }

  useEffect(() => {
    if (displayAlbums) {
      fetchData(gonationID, displayAlbums[locationIndex])
    }
    return () => {}
  }, [mediaServerURL])

  return (
    <>
      <Box variant={`${variantName}.hero`} sx={styles}>
        <HeroContent
          titles={titles}
          subtitles={subtitles}
          texts={texts}
          textType={textType}
          desc={desc}
          ctaNames={ctaNames}
          ctaLinks={ctaLinks}
          links={links}
          locationIndex={locationIndex}
          logoHero={logoHero}
          city={city}
          variantName={variantName}
          imageBaseUrl={logoBaseUrl}
          imagePrefix={logoPrefix}
          isMultiLocationSite={isMultiLocationSite}
        />

        {/* if the gallery has loaded use that if not then use the images provided in options else use nothing */}
        {console.log('original images in hero:', images)}
        {console.log('transformed images in hero:', transformedImages)}
        {console.log('mediaServerURL:', mediaServerURL)}
        {gallery ? (
          <Slider {...settings} key={nanoid()}>
            {gallery.photos.map(image => (
              <Image key={nanoid()} src={image.imageUrl} alt="Cloudinary_Image" />
            ))}
          </Slider>
        ) : transformedImages ? (
          <Slider {...settings} key={nanoid()}>
            {transformedImages.map(image => (
              <ImageSelector
                key={nanoid()}
                image={image} // transformed image URL
                poweredImages={props.poweredImages} // powered iamges object
                locationIndex={locationIndex}
              />
            ))}
          </Slider>
        ) : (
          ''
        )}
        {shoutData?.shout && (
          <Box
            variant={`${variantName}.shoutWidgetContainer`}
            className="shoutWidgetContainer"
            sx={{
              ...shoutStyles
            }}
          >
            <Shout
              shoutData={shoutData}
              // variantName={`${variantName}.shoutWidget`}
              className="shoutWidget"
            />
          </Box>
        )}
      </Box>
    </>
  )
}
